import { styled } from 'utils';
import { typography, TypographyProps } from 'styled-system';

export const CurrencyCode = styled.span<TypographyProps>`
	width: 40px;
	text-align: right;
	display: inline-block;
	${typography};
`;
